import { Link } from 'react-router-dom';
import { formatClock } from '../MentorAvailabilityPanel';
import type { MenteeBookingRow } from './MenteePortalService';
import { formatModeLabel } from './menteeSessionsFormat';

type Props = {
    bookings: MenteeBookingRow[];
    menteeName: string | null;
    isLoading: boolean;
};

function formatDateShortParts(dateStr?: string | null) {
  if (!dateStr) return { month: '—', day: '' };
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return { month: '—', day: '' };
  return {
    month: d.toLocaleDateString('en-US', { month: 'short' }).toUpperCase(),
    day: String(d.getDate()).padStart(2, '0'),
  };
}

const MenteeDashboardUpcoming = ({ bookings, menteeName, isLoading }: Props) => {
    if (isLoading) {
        return (
            <section className="mdash-card">
                <h2 className="mdash-card-title">Upcoming Sessions</h2>
                <p className="mdash-empty">Loading…</p>
            </section>
        );
    }

    if (bookings.length === 0) {
        return (
            <div className="card border-0 shadow-sm rounded-3 overflow-hidden bg-white flex-grow-1">
                  <div className="card-header bg-white border-bottom border-light-subtle p-3 d-flex align-items-center justify-content-between">
                    <h6 className="fw-bold mb-0 text-dark">Upcoming Sessions</h6>
                    
                    <Link
                            to="/alumni/mentorship/mentee/sessions"
                            className="btn btn-link text-primary p-0 font-12 fw-bold text-decoration-none"
                        >
                           <span>Book a session →</span>
                        </Link>
                  </div>
                  <div className="card-body p-4 text-center d-flex flex-column align-items-center justify-content-center" id="dashboard-upcoming-session-area">
                    <div className="fs-1 mb-2 text-muted">📭</div>
                    <div className="fw-bold font-14 text-dark mb-1">No sessions booked yet</div>
                    <div className="text-secondary small mb-3">Your mentor has open slots — book one before they fill up!</div>
                    
                      <Link
                            to="/alumni/mentorship/mentee/sessions"
                            className="btn btn-green"
                        >
                           <span><i className="bi bi-calendar-event"></i> Book Your First Session</span>
                        </Link>
                  </div>
                </div>
        );
    }

    return (
        <>
            <div className="card border-0 shadow-sm rounded-3 overflow-hidden bg-white flex-grow-1">
                <div className="card-header bg-white border-bottom border-light-subtle p-3 d-flex align-items-center justify-content-between">
                    <h6 className="fw-bold mb-0 text-dark">Upcoming Sessions</h6>
                    <Link
                            to="/alumni/mentorship/mentee/sessions"
                            className="btn btn-link text-primary p-0 font-12 font-500 text-decoration-none"
                        >
                           <span>Book a session →</span>
                        </Link>
                </div>
                <div
                    className="card-body p-4"
                    id="dashboard-upcoming-session-area">
                    <div className="row g-3">
                        
                         {bookings.map((row) => (
                            <div className="col-lg-4 col-md-4 col-sm-6" key={row.id}>
                                <div  className="d-flex align-items-start gap-3 w-100 bg-success bg-opacity-10 border border-success border-opacity-25 rounded-3 p-3 shadow-sm h-100">
                                    <div
                                        className="bg-white p-3 rounded-3 text-center d-flex flex-column align-items-center justify-content-center"
                                        // style={{ width: '50px', height: '50px' }}
                                        >
                                        
                                        {(() => {
                                        const { month, day } = formatDateShortParts(row.bookedDate);
                                        return (
                                            <>
                                            <div className="font-700 text-success fs-4 lh-1">{day}</div>
                                            <div className="text-uppercase text-success font-12 fw-bold">{month}</div>
                                            </>
                                        );
                                        })()}
                                    </div>
                                    <div className="flex-grow-1">
                                        <div className="font-16 font-600 text-dark mb-0">{row.topic || '—'}</div>
                                        <div className="text-secondary-emphasis font-12 font-400">1:1 · {formatModeLabel(row.mode)} · Booked by {menteeName || 'You'}</div>
                                        <div className="badge bg-green text-white font-11 font-500 mt-1 rounded-pill">Confirmed</div>
                                    </div>

                                
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            
        </>
    );
};

export default MenteeDashboardUpcoming;
